import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { RouterModule } from '@angular/router';

import { RippleDirective } from '@directives/ripple.directive';
import { SliderLinkDirective } from '@directives/slider-link.directive';

@Component({
  selector: 'app-card',
  imports: [NgClass, NgStyle, RouterModule, RippleDirective, SliderLinkDirective],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() link?: string | any[];
  @Input() fragment?: string;
  @Input() title?: string;
  @Input() width?: number;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  click(): void {
    this.clicked.emit();
  }
}
